import { useContext } from "react";

import PropTypes from "prop-types";

import { AccordionContext } from "common/contexts";

/**
 * Contexts
 */
import context from "./context";
import contextItem from "./context-item";

/** ========== */

const AccordionBBCButton = ({ children, ...props }) => {
  const { multipleOpen } = useContext(context);
  const { active, setActive } = useContext(AccordionContext);
  const { eventKey } = useContext(contextItem);

  const handleOnClick = (clickEvent) => {
    const listActive = [...active];
    const includes = listActive.includes(clickEvent);

    if (multipleOpen) {
      setActive(
        includes
          ? listActive.filter((item) => item !== clickEvent)
          : [...listActive, clickEvent]
      );
    } else {
      setActive(includes ? [] : [clickEvent]);
    }
  };

  return (
    <div {...props} onClick={() => handleOnClick(eventKey)}>
      {children}
    </div>
  );
};

export default AccordionBBCButton;

AccordionBBCButton.propTypes = {
  children: PropTypes.node.isRequired,
};

/** ========== */
